$(() => {
    var url: any = $('#noticia-full-url').val();
    $('#noticia-full-url').remove();
    var refcontent;
    var refthumbs;
    var thumbs;

    $('.thumbs').each(function () {
        var refthumbs = $(this).attr('data-ref');
        const thumbs = new Swiper('.mySwiper-' + refthumbs, {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
        });
        // $('.content').each(function () {
        // var refcontent = $('.content').attr('data-ref');
        const swiper2 = new Swiper('.mySwiper2-' + refthumbs, {
            spaceBetween: 5,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: thumbs,
            },
        });
        // });
    });

    console.log(refcontent);
    console.log(refthumbs);

    $('.n-c-social-btn.fb').click(() => {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
    });

    $('.n-c-social-btn.tw').click(() => {
        window.open('http://twitter.com/share?url=' + encodeURIComponent(url), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
    });
});
